import containerSizeSuggesterStyles from './container-size-suggester';

function GetContainerSizeSuggestion() {
  var xhr = new XMLHttpRequest();
  var url = "/api/PODS/ContainerSizeSuggester/" + document.getElementById("slctFurnishingAmount").value + "/" + document.getElementById("slctHomeSize").value + "/" + include12foot;
  xhr.open("GET", url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) { var json = JSON.parse(xhr.responseText); document.getElementById("spnSuggestion").innerHTML = json.Suggestion }
  };
  xhr.send()
}
